import React from 'react';

export interface ComparisonPanelProps {
  onSelectSubroute?: (route: string) => void;
}

/**
 * ComparisonPanel (SSW Shell Boundary)
 *
 * Structural shell for multi-scenario delta analysis, mesh sensitivity studies,
 * and aerodynamic configuration comparisons.
 */
export const ComparisonPanel: React.FC<ComparisonPanelProps> = () => {
  return (
    <div className="ssw-dock-panel" role="tabpanel" id="ssw-dock-panel-comparison" aria-labelledby="ssw-dock-tab-comparison">
      <div className="ssw-dock-panel-header">
        <div className="ssw-dock-panel-title-group">
          <span className="ssw-dock-panel-kicker">SCENARIO & DESIGN VARIANT DIFF</span>
          <h3 className="ssw-dock-panel-title">Comparison</h3>
        </div>
        <div className="ssw-dock-panel-badge">AWAITING MULTI-RUN DATA</div>
      </div>

      <div className="ssw-dock-panel-body">
        <div className="ssw-deferred-card">
          <div className="ssw-deferred-indicator" aria-hidden="true" />
          <span className="ssw-deferred-title">CONTENT DEFERRED</span>
          <p className="ssw-deferred-desc">
            Differential field subtraction (ΔU, Δp), pedestrian comfort classification overlays,
            and design iteration matrix comparisons will be established during the Comparison Phase.
          </p>
          <div className="ssw-deferred-meta">
            <span>SCENARIOS: 1 BASELINE REGISTERED</span>
            <span>COMPARATIVE ENGINE: SUSPENDED</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComparisonPanel;
